const emptyPendingReferralAction = () => ({ providerReceived: 0, providerMade: 0, patientReceived: 0 })

export default {
    namespaced: true,

    state: {
        token: null,
        user: {},
        practice: {},
        members: [],
        userLocations: [],
        lastRegisteredPhysician: null,
        facilityServicesByLocation: [],
        pendingReferralAction: emptyPendingReferralAction(),
        insurancePlans: [],
        sessionHydrated: false,
    },

    getters: {
        getToken(state) {
            return state.token
        },

        getUser(state) {
            return state.user
        },

        getPractice(state) {
            return state.practice
        },

        getMembers(state) {
            return state.members
        },

        getLastRegisteredPhysician(state) {
            return state.lastRegisteredPhysician
        },

        getUserLocations(state) {
            return state.userLocations
        },

        getFacilityServicesByLocation(state) {
            return state.facilityServicesByLocation
        },

        getPendingReferralAction(state) {
            return state.pendingReferralAction
        },

        getProviderPendingReferralActionCount(state) {
            return (state.pendingReferralAction.providerReceived || 0) + (state.pendingReferralAction.providerMade || 0)
        },

        getPatientPendingReferralActionCount(state) {
            return state.pendingReferralAction.patientReceived || 0
        },

        getInsurancePlans(state) {
            return state.insurancePlans
        },

        isSessionHydrated(state) {
            return state.sessionHydrated
        },
    },

    mutations: {
        setToken(state, token) {
            state.token = token
        },

        setUser(state, user) {
            state.user = user
        },

        setPractice(state, practice) {
            state.practice = practice
        },

        setMembers(state, members) {
            state.members = members
        },

        setLastRegisteredPhysician(state, physician) {
            state.lastRegisteredPhysician = physician
        },

        setUserLocations(state, locations) {
            state.userLocations = locations
        },

        setFacilityServicesByLocation(state, facilityServicesByLocation) {
            state.facilityServicesByLocation = facilityServicesByLocation
        },

        setPendingReferralAction(state, pendingReferralAction) {
            state.pendingReferralAction = { ...emptyPendingReferralAction(), ...pendingReferralAction }
        },

        setInsurancePlans(state, insurancePlans) {
            state.insurancePlans = insurancePlans
        },

        setSessionHydrated(state, sessionHydrated) {
            state.sessionHydrated = sessionHydrated
        },

        clearInsurancePlans(state) {
            state.insurancePlans = []
        },

        clearSessionHydrated(state) {
            state.sessionHydrated = false
        },

        clearToken(state) {
            state.token = null
        },

        clearUser(state) {
            state.user = {}
        },

        clearPractice(state) {
            state.practice = {}
        },

        clearMembers(state) {
            state.members = []
        },

        clearLastRegisteredPhysician(state) {
            state.lastRegisteredPhysician = null
        },

        clearUserLocations(state) {
            state.userLocations = []
        },

        clearFacilityServicesByLocation(state) {
            state.facilityServicesByLocation = []
        },

        clearPendingReferralAction(state) {
            state.pendingReferralAction = emptyPendingReferralAction()
        },
    },

    actions: {
        setToken(Store, token) {
            Store.commit('setToken', token)
        },

        setUser(Store, user) {
            Store.commit('setUser', user)
        },

        setPractice(Store, practice) {
            Store.commit('setPractice', practice)
        },

        setMembers(Store, members) {
            Store.commit('setMembers', members)
        },

        setLastRegisteredPhysician(Store, physician) {
            Store.commit('setLastRegisteredPhysician', physician)
        },

        setUserLocations(Store, locations) {
            Store.commit('setUserLocations', locations)
        },

        setFacilityServicesByLocation(Store, facilityServicesByLocation) {
            Store.commit('setFacilityServicesByLocation', facilityServicesByLocation)
        },

        setPendingReferralAction(Store, pendingReferralAction) {
            Store.commit('setPendingReferralAction', pendingReferralAction)
        },

        setInsurancePlans(Store, insurancePlans) {
            Store.commit('setInsurancePlans', insurancePlans)
        },

        setSessionHydrated(Store, sessionHydrated) {
            Store.commit('setSessionHydrated', sessionHydrated)
        },

        clear(Store) {
            Store.commit('clearToken')
            Store.commit('clearUser')
            Store.commit('clearPractice')
            Store.commit('clearMembers')
            Store.commit('clearLastRegisteredPhysician')
            Store.commit('clearUserLocations')
            Store.commit('clearFacilityServicesByLocation')
            Store.commit('clearPendingReferralAction')
            Store.commit('clearInsurancePlans')
            Store.commit('clearSessionHydrated')
        },
    },
}
